export function getLogoNamespace(title: string) {
  let namespace;

  switch (title) {
    case 'FLNL':
    case 'FLBE':
      namespace = 'flu';
      break;
    case 'BSVW':
      namespace = 'svw';
      break;
    case 'BVWO':
      namespace = 'vtw';
      break;
    case 'BWOL':
      namespace = 'wls';
      break;
    case 'BFLN':
      namespace = 'flw';
      break;
    case 'BDON':
      namespace = 'don';
      break;
    case 'BDAN':
      namespace = 'dat';
      break;
    case 'WLS':
      namespace = 'vtw';
      break;
    default:
      namespace = title?.toLowerCase();
  }

  return namespace;
}

/**
 * Multiple brands can be styled under one namespace. E.g. ED and PZ fall under adb.
 * Given a brand, returns such namespace.
 */
export function getStyleNamespace(title: string, groupAdr: boolean = true) {
  if (!title) return '';

  let namespace;

  switch (title) {
    case 'ad':
    case 'bd':
    case 'bs':
    case 'dg':
    case 'st':
    case 'tt':
      if (groupAdr) {
        namespace = 'adr';
      } else {
        namespace = title.toLowerCase();
      }
      break;
    case 'ed':
    case 'pz':
      if (groupAdr) {
        namespace = 'adb';
      } else {
        namespace = title.toLowerCase();
      }
      break;
    case 'bsvw':
      namespace = 'svw';
      break;
    case 'bvwo':
    case 'wls':
      namespace = 'vtw';
      break;
    case 'bwol':
      namespace = 'wls';
      break;
    case 'bfln':
      namespace = 'flw';
      break;
    case 'bdan':
      namespace = 'dat';
      break;
    case 'lib':
    case 'libsp':
    case 'libbo':
    case 'libpz':
      namespace = 'lib';
      break;
    case 'flnl':
    case 'flbe':
      namespace = 'flu';
      break;
    case 'mar':
    case 'marsp':
    case 'marpz':
      namespace = 'mar';
      break;
    case 'don':
    case 'donex':
    case 'donpo':
    case 'bdon':
      namespace = 'don';
      break;
    case 'tsbe':
    case 'pak12':
      namespace = 'lezerij';
      break;
    case 'aut':
    case 'atr':
      namespace = 'aut';
      break;
    case 'kiosk':
    case 'kioskbe':
      namespace = 'kiosk_aneklatin';
      break;
    default:
      namespace = title.toLowerCase();
  }

  return namespace;
}
